import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppSignOut } from '@/shared/hooks/useAppSignOut'
import { markAuthRoleMismatch } from '@/shared/hooks/useAuthMismatchNotice'

export default function NotAuthenticated() {
  const navigate = useNavigate()
  const signOut = useAppSignOut()
  const hasSignedOut = useRef(false)

  // Der Riegel ersetzt die leere Abhaengigkeitsliste: abgemeldet wird genau einmal,
  // auch wenn der Hook eine neue Funktion liefert.
  useEffect(() => {
    if (hasSignedOut.current) return
    hasSignedOut.current = true
    markAuthRoleMismatch()
    void signOut()
  }, [signOut])

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white dark:bg-background px-4">
      <h1 className="text-xl font-semibold text-center mb-6">
        Hoppala, hier kannst du dich nicht einloggen!
      </h1>
      <button
        onClick={() => navigate(-1)}
        className="bg-primary text-white px-6 py-2 rounded-xl hover:bg-primary/90 transition"
      >
        Zurück
      </button>
    </div>
  )
}
